
// import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
// import 'babel-polyfill'
import Es6Promise from 'es6-promise'
// import '@babel/core'

// import style
import 'swiper/css/swiper.css'

Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper /* { default options with global component } */)
Vue.use(ViewUI)

Es6Promise.polyfill()
Vue.prototype.globalClick = function (callback) {
  document.getElementById('app').onclick = function (e) {
    console.log('e', e.target.id)
    if (!e.target.id) {
      callback()
    }
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
